export const containerSx = {
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gridTemplateRows: 'repeat(2, 1fr)',
	columnGap: '32px',
	rowGap: '32px'
}

export const items1Sx = [
	{ gridArea: '1 / 1 / 2 / 2' },
	{ gridArea: '1 / 2 / 2 / 4' },
	{ gridArea: '2 / 1 / 3 / 3' },
	{ gridArea: '2 / 3 / 3 / 4' }
]

export const items2Sx = [
	{ gridArea: '1 / 1 / 2 / 3' },
	{ gridArea: '1 / 3 / 2 / 4' },
	{ gridArea: '2 / 1 / 3 / 2' },
	{ gridArea: '2 / 2 / 3 / 4' }
]
